import type { AnatomyState } from "./types";

const ANATOMY_SET_ANSWER = "ANATOMY/Set Answer";
const ANATOMY_SUBMIT = "ANATOMY/Submit";
const ANATOMY_RESET = "ANATOMY/Reset";

export const ANATOMY_ACTIONS = {
  SET_ANSWER: ANATOMY_SET_ANSWER,
  SUBMIT: ANATOMY_SUBMIT,
  RESET: ANATOMY_RESET,
};

interface AnatomyReducerState {
  [componentId: string]: AnatomyState;
}

const DEFAULT_STATE: AnatomyState = {
  answers: {},
  correctAnswers: [],
  incorrectAnswers: [],
  isSubmitted: false,
  showFeedback: false,
};

interface SetAnswerAction {
  type: typeof ANATOMY_SET_ANSWER;
  payload: { componentID: string; calloutId: string; value: string };
}

interface SubmitAction {
  type: typeof ANATOMY_SUBMIT;
  payload: {
    componentID: string;
    callouts: { id: string; correctAnswer: string }[];
  };
}

interface ResetAction {
  type: typeof ANATOMY_RESET;
  payload: string;
}

type AnatomyAction = SetAnswerAction | SubmitAction | ResetAction;

export const anatomyReducer = (
  state: AnatomyReducerState = {},
  action: AnatomyAction
): AnatomyReducerState => {
  switch (action.type) {
    case ANATOMY_SET_ANSWER: {
      const { componentID, calloutId, value } = action.payload;
      const current = state[componentID] || DEFAULT_STATE;
      const incorrectAnswers = current.incorrectAnswers.filter(
        (id) => id !== calloutId
      );
      return {
        ...state,
        [componentID]: {
          ...current,
          answers: { ...current.answers, [calloutId]: value },
          incorrectAnswers,
          showFeedback:
            incorrectAnswers.length === current.incorrectAnswers.length
              ? current.showFeedback
              : false,
        },
      };
    }
    case ANATOMY_SUBMIT: {
      const { componentID, callouts } = action.payload;
      const current = state[componentID] || DEFAULT_STATE;
      const correct: string[] = [];
      const incorrect: string[] = [];

      callouts.forEach((callout) => {
        if (current.answers[callout.id] === callout.correctAnswer) {
          correct.push(callout.id);
        } else {
          incorrect.push(callout.id);
        }
      });

      return {
        ...state,
        [componentID]: {
          ...current,
          isSubmitted: true,
          correctAnswers: correct,
          incorrectAnswers: incorrect,
          showFeedback: true,
        },
      };
    }
    case ANATOMY_RESET: {
      const componentID = action.payload;
      return {
        ...state,
        [componentID]: { ...DEFAULT_STATE },
      };
    }
    default:
      return state;
  }
};
